import request from "@/axios/index"

// 字典
export const dictApi = (dictType) => {
    return request({
        url: `/system/dict/data/type/${dictType}`,
        method: "get"
    })
}

//获取地区列表
export const areaListApi = () => {
    return request({
        url: `/dc/area/areaList`,
        method: "get"
    })
}

//保存用户需求
export const saveUserRequirementApi = (data) => {
    return request({
        url: `/api/gateway/user/save`,
        method: "post",
        data: data
    })
}

//产业政策列表
export const getPolicyListApi = (params) => {
    return request({
        url: `/api/gateway/queryPolicy`,
        method: "get",
        params: params
    })
}

//产业政策详情
export const getPolicyDetailApi = (id) => {
    return request({
        url: `/api/gateway/queryPolicyDetail/${id}`,
        method: "get"
    })
}

//产业动态列表
export const getIndustryNewsListApi = (params) => {
    return request({
        url: `/api/gateway/industryNews/list`,
        method: "get",
        params: params
    })
}

//产业动态详情
export const getIndustryNewsDetailApi = (params) => {
    return request({
        url: `/api/gateway/industryNews/detail`,
        method: "get",
        params: params
    })
}

//合作项目分类
export const getProjectCategoriesApi = (params) => {
    return request({
        url: `/api/gateway/menu/list`,
        method: "get",
        params: params
    })
}

//合作项目列表
export const getProjectListApi = (params) => {
    return request({
        url: `/api/gateway/content/list`,
        method: "get",
        params: params
    })
}

//会客厅列表
export const getIndustryLoungeListApi = (params) => {
    return request({
        url: `/api/gateway/industryLounge/list`,
        method: "get",
        params: params
    })
}

//会客厅列表详情
export const getIndustryLoungeDetailApi = (id) => {
    return request({
        url: `/api/gateway/industryLounge/detail/${id}`,
        method: "get"
    })
}

//报名
export const userEnrollApi = (data) => {
    return request({
        url: `/api/gateway/user/enroll?loungeId=${data.loungeId}`,
        method: "post",
        data: data
    })
}


